import { Web3Modal } from '@web3modal/react';

import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '#/routes-external';

import { c7239C4 } from '#/colors';
import { useWalletConnectConfig } from '#/features/wallet/wallet-connect-context';

const theme = {
  '--w3m-accent-color': c7239C4,
  '--w3m-background-color': c7239C4,
};

/**
 * Loads the WalletConnect modal.
 * Rendering this component makes assets load in the background.
 * To reduce page load time, it can be rendered only when needed.
 */
export default function WalletConnectModal() {
  const config = useWalletConnectConfig();

  return (
    <Web3Modal
      projectId={config.projectId}
      ethereumClient={config.ethereumClient}
      themeMode="dark"
      explorerRecommendedWalletIds={config.recommendedWalletIds}
      explorerExcludedWalletIds="ALL"
      defaultChain={config.chain}
      termsOfServiceUrl={TERMS_OF_SERVICE_URL}
      privacyPolicyUrl={PRIVACY_POLICY_URL}
      themeVariables={theme}
    />
  );
}
